import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DBPharmacy } from 'db/schema/pharmacies';
import { RootState } from 'lib/store';

export interface PharmacySlice {
  selections: DBPharmacy[];
}

export const initialState: PharmacySlice = {
  selections: [],
};

const pharmacySlice = createSlice({
  initialState,
  name: 'pharmacy',
  reducers: {
    setPharmacies: (state, action: PayloadAction<DBPharmacy[]>) => {
      return {
        selections: action.payload,
      };
    },
    addPharmacy: (state, action: PayloadAction<DBPharmacy>) => {
      return {
        selections: [...state.selections, action.payload],
      };
    },
    removePharmacy: (state, action: PayloadAction<DBPharmacy>) => {
      return {
        selections: state.selections.filter((item) => {
          return item.id !== action.payload.id;
        }),
      };
    },
  },
});

const { actions, reducer } = pharmacySlice;

export const { setPharmacies, addPharmacy, removePharmacy } = actions;

export const selectPharmacies = (state: RootState) => state.pharmacy.selections;

export default reducer;
